import { atom, useAtomValue } from 'jotai'
import { RestaurantMenusFragment } from '~/features/guide/menus/query'
import { getFragmentData } from '~/lib/graphql'
import { restaurant$ } from '../scope'
import type { Menus } from './query'

export const menus$ = atom<Menus>(
  (get) => getFragmentData(RestaurantMenusFragment, get(restaurant$))?.menus ?? null
)

export function useMenus() {
  return useAtomValue(menus$)
}
